module.exports = __webpack_public_path__ + "img/employees.dfa26909.svg";